<template>
  <div class="popup_view">
    <mt-popup
      v-model="isShow"
      popup-transition="popup-fade" :closeOnClickModal="false" class="popup-wrapper">
      <div class="popup">
        <p class="tishi">提示</p>
        <p class="desc">{{desc}}</p>
        <div class="sure-reset">
          <span class="reset clearfix" @click="goIdent">去认证</span>
          <span class="sure clearfix" @click="goCancel">取消</span>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: ['desc', 'isShow'],
    methods: {
      // 取消
      goCancel() {
        this.$emit('goCancel')
      },
      // 去认证
      goIdent() {
        this.$emit('goIdent')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../common/sass/mixin.scss";
  .popup_view {
    width: 100%;
    .popup-wrapper {
      width: 70%;
      height: 24%;
      z-index: 2;
      border-radius: 15px;
      .popup {
        padding: 10px 0;
        p {
          text-align: center;
        }
        .tishi {
          margin-bottom: 20px;
          font-size: 18px;
          font-weight: 700;
        }
        .desc-bottom {
          font-size: 15px;
          color: #666;
          padding: 0 10px 23px 10px;
          line-height: 16px;
        }
        .desc {
          font-size: 15px;
          color: #666;
        }
        .sure-reset {
          width: 100%;
          font-size: 16px;
          position: absolute;
          bottom: 0;
          left: 0;
          border-top: 1px solid #f0f0f0;
          .reset {
            padding: 10px 0;
            display: inline-block;
            text-align: center;
            width: 50%;
            color: #666;
            border-right: 1px solid #f0f0f0;
          }
          .sure {
            text-align: center;
            width: 49%;
            padding: 10px 0;
            float: right;
            color: #0078de;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/popupView.vue